<form [formGroup]="profileForm" (ngSubmit)="onSubmit()">
  <div class="wrapper">
    <div class="container px-0">
      <div>
        <div class="main-info">
          {{ 'madisonverification.formInfo' | translate }}
        </div>
        <div *ngIf="isLockScreen" class="main-info" style="font-size: 20px; text-transform: uppercase;">
          {{ 'madisonverification.sessionLocked' | translate }}
        </div>
        <div class="">
          <div class="form-row">
            <div class="col-md-4">
              <div class="form-group">
                <div class="input-icon form-floating">
                  <input type="text" class="form-control" maxlength="35" formControlName="firstName"
                         (input)="onlyCharAllow($event.target,'firstName')"
                         placeholder="{{ 'madisonverification.firstNamePlaceholder' | translate }}" />
                  <label>{{ 'madisonverification.firstNameLabel' | translate }} <span class="text-danger">*</span></label>
                </div>
                <div>
                  <span id="f-zip-err"
                        *ngIf="profileForm.controls['firstName'].touched && profileForm.controls['firstName'].invalid">
                    <span class="err"
                          *ngIf="profileForm.controls['firstName'].errors && profileForm.controls['firstName'].errors.required">
                      {{ 'madisonverification.firstNameError' | translate }}
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <div class="position-relative input-icon form-floating">
                  <input type="text" class="form-control" maxlength="35" formControlName="lastName"
                         (input)="onlyCharAllow($event.target,'lastName')"
                         placeholder="{{ 'madisonverification.lastNamePlaceholder' | translate }}">
                  <label>{{ 'madisonverification.lastNameLabel' | translate }} <span class="text-danger">*</span></label>
                </div>
                <div>
                  <span id="f-zip-err" class="err"
                        *ngIf="profileForm.controls['lastName'].touched && profileForm.controls['lastName'].invalid">
                    <span class="err"
                          *ngIf="profileForm.controls['lastName'].errors && profileForm.controls['lastName'].errors.required">
                      {{ 'madisonverification.lastNameError' | translate }}
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <div class="position-relative form-floating">
                  <input type="date" class="form-control" formControlName="dob" (focusout)="focusOutFunction($event, 0)" max="{{curDate | date:'yyyy-MM-dd'}}"
                         placeholder="{{ 'madisonverification.dobPlaceholder' | translate }}">
                  <label>{{ 'madisonverification.dobLabel' | translate }} <span class="text-danger">*</span></label>
                </div>
                <span id="f-zip-err" class="err"
                      *ngIf="profileForm.controls['dob'].touched && profileForm.controls['dob'].invalid">
                  <span class="err"
                        *ngIf="profileForm.controls['dob'].errors && profileForm.controls['dob'].errors.required">
                    {{ 'madisonverification.dobError' | translate }}
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <footer class="p-3">
    <div class="container p-0">
      <div class="text-right">
        <button class="btn btn-primary" type="button" (click)="onSubmit()">{{ 'madisonverification.nextButtonText' | translate }}</button>
      </div>
    </div>
  </footer>
</form>

<!-- Modals using translation -->
<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="incorrectinfo-model">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body p-4 text-center">
        <h5 class="font-weight-bolder mb-3">
          {{ 'madisonverification.modalUnableToVerifyInfo' | translate }}
        </h5>
        <button type="button" data-toggle="modal" data-dismiss="modal" id="closeDeleteFamilyHistory"
                class="btn btn-primary">
          {{ 'madisonverification.modalOkButtonText' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="isNotValid_linkexiting">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body p-4 text-center">
        <h5 class="font-weight-bolder mb-3 text-danger">
          {{ 'madisonverification.modalInvalidLinkTitle' | translate }}
        </h5>
        <p class="mb-3">{{ 'madisonverification.modalInvalidLinkMessage' | translate }}</p>
      </div>
    </div>
  </div>
</div>
